var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitchIconNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#6B758B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_501_409",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#DEDEDE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_501_409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9419 3.42375C15.6473 2.75862 14.263 2.27524 12.8157 2C12.638 2.35285 12.4304 2.82744 12.2872 3.20498C10.7487 2.95093 9.22445 2.95093 7.7143 3.20498C7.57116 2.82744 7.3588 2.35285 7.17947 2C5.73067 2.27524 4.3448 2.7604 3.05016 3.42727C0.438869 7.76019 -0.269009 11.9855 0.0849305 16.1508C1.81688 17.571 3.49534 18.4337 5.14548 18.9983C5.55291 18.3825 5.91628 17.728 6.22931 17.0382C5.63313 16.7895 5.06211 16.4825 4.52256 16.1261C4.6657 16.0097 4.80571 15.8879 4.94098 15.7627C8.23183 17.4528 11.8074 17.4528 15.0589 15.7627C15.1958 15.8879 15.3358 16.0097 15.4774 16.1261C14.9362 16.4842 14.3637 16.7912 13.7675 17.04C14.0805 17.728 14.4423 18.3843 14.8513 19C16.503 18.4355 18.183 17.5728 19.915 16.1508C20.3303 11.3221 19.2056 7.13565 16.9419 3.42375ZM6.67765 13.5892C5.68977 13.5892 4.87963 12.5765 4.87963 11.3433C4.87963 10.1101 5.67247 9.0957 6.67765 9.0957C7.68285 9.0957 8.49297 10.1083 8.47567 11.3433C8.47723 12.5765 7.68285 13.5892 6.67765 13.5892ZM13.3223 13.5892C12.3344 13.5892 11.5243 12.5765 11.5243 11.3433C11.5243 10.1101 12.3171 9.0957 13.3223 9.0957C14.3275 9.0957 15.1376 10.1083 15.1203 11.3433C15.1203 12.5765 14.3275 13.5892 13.3223 13.5892Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitchIconNew);
export default __webpack_public_path__ + "static/media/twitch-icon-new.5b37b85211f1f46694bb3533c26e39d7.svg";
export { ForwardRef as ReactComponent };